<template>
  <div class="main">
    <div class="router">
      <div class="card">
        <div class="card-header">
          <el-breadcrumb>
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>用户档案</el-breadcrumb-item>
          </el-breadcrumb>

          <el-button
            type="primary"
            icon="el-icon-refresh"
            circle
            @click="refresh"
          ></el-button>
        </div>
        <!--搜索-->
        <div class="search">
          <el-select v-model="doctor_id" placeholder="请选择医生">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            placeholder="请输入用户姓名"
            v-model="username"
            class="input-with-select"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
          </el-input>
        </div>

        <!--添加-->
        <div class="create">
          <span>共有数据: {{ total }} 条</span>
        </div>
        <!--数据-->
        <div class="card-body text">
          <el-table :data="data" style="width: 100%">
            <el-table-column label="测评医生">
              <template slot-scope="scope">
                <span
                  style="color: #5cb87a"
                  v-text="scope.row.doctor.username"
                ></span>
              </template>
            </el-table-column>
            <el-table-column prop="username" label="姓名"> </el-table-column>
            <el-table-column prop="sex" width="100" label="性别">
              <template slot-scope="scope">
                <span style="color: #409eff" v-if="scope.row.sex == 1">男</span>
                <span style="color: #f56cfc" v-else>女</span>
              </template>
            </el-table-column>
            <el-table-column prop="birthday" label="出生日期" width="150">
            </el-table-column>
            <el-table-column prop="phone" label="联系方式" width="150">
            </el-table-column>
            <el-table-column prop="father_height" width="100" label="父亲身高">
            </el-table-column>
            <el-table-column prop="mother_height" width="100" label="母亲身高">
            </el-table-column>
            <el-table-column prop="hope_height" width="100" label="期望身高">
            </el-table-column>
            <el-table-column prop="create_time" label="注册时间">
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  style="color: #f56c6c"
                  @click="del(scope.row.id, scope.$index)"
                  type="text"
                  size="small"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--分页-->
      <div class="page">
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          @current-change="handle_page"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {
        username: '',
        doctor_id: 0,
        page: 1,
        pageSize: 20,
        total: 0,
        options: [],
        data: [],
      }
    },
    created() {
      this._member()
      this._request()
    },
    methods: {
      _request() {
        this.$request(
          `archives?page=${this.page}&username=${this.username}&uid=${this.doctor_id}`
        ).then((res) => {
          this.data = res.data.data
          this.page = res.data.current_page
          this.pageSize = res.data.per_page
          this.total = res.data.total
        })
      },
      _member() {
        this.$request(`member/list`).then((res) => {
          if (res.error_code === 10000) {
            this.options = [{ label: '全部', value: 0 }]
            res.data.map((item) => {
              this.options.push({
                label: item.username,
                value: item.id,
              })
            })
          }
        })
      },
      handle_page(e) {
        this.page = e
        this._request()
      },
      search() {
        this._request()
      },
      del(id, key) {
        this.$request(`archives/${id}`, '', 'delete').then((res) => {
          if (res.error_code === 10000) {
            this.data.splice(key, 1)
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          }
        })
      },
      refresh() {
        this.page = 1
        this.username = ''
        this.doctor_id = ''
        this._request()
      },
    },
  }
</script>

<style>
  .search {
    display: flex;
  }
  .el-select {
    margin-right: 10px;
  }
</style>
